export default __webpack_public_path__ + "static/media/logo_catlike.e3a8d005.png";